import { Formik, Form as FormikForm, FormikProps, FormikHelpers } from "formik";
import React, { useRef } from "react";
import { Button, Col, Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useSetDomainUrlMutation } from "../../../../graphql/projects.hooks";
import AddDomainLogo from "../../../newProject/domainSetup/img/addDomain.webp";
import { IUserDomainForm } from "../../../newProject/domainSetup/userDomainView";
import {
  validationDomain,
  validationSubdomain,
} from "../../../../validations/newProject";
import DomainInput from "../../../../components/inputs/domainInput";
import { DomainType } from "../../../../constants";

interface IDomainNameProps {
  domainId: number;
  setStep: (step: number) => void;
  isSubdomainMode?: boolean;
  userDomain: React.MutableRefObject<string>;
}

export default function DomainName({
  domainId,
  setStep,
  isSubdomainMode = false,
  userDomain,
}: IDomainNameProps) {
  const { t } = useTranslation();
  const formRef = useRef<FormikProps<IUserDomainForm>>(null);
  const [setDomain, { loading: setDomainUrlLoading, error }] =
    useSetDomainUrlMutation();

  const initialValues: IUserDomainForm = {
    domain: "",
  };

  const onSubmit = async (
    values: IUserDomainForm,
    { setSubmitting }: FormikHelpers<IUserDomainForm>
  ) => {
    try {
      await setDomain({
        variables: {
          domainId,
          urlType: isSubdomainMode
            ? DomainType.UserSubdomain
            : DomainType.UserDomain,
          domainUrl: values.domain,
        },
        onCompleted: () => {
          setStep(2);
        },
      });
    } catch (error) {}

    setSubmitting(false);
  };

  return (
    <Col md={8} lg={6} className="mx-auto">
      <Col xs={7} md={12} className="mx-auto px-2 px-md-0 text-center">
        <img
          src={AddDomainLogo}
          loading="lazy"
          alt="Add Domain"
          className="img-fluid mt-4 mb-3 pb-2"
        />
      </Col>

      <Formik
        innerRef={formRef}
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={
          isSubdomainMode ? validationSubdomain(t) : validationDomain(t)
        }
      >
        {({ touched, errors, values }) => {
          userDomain.current = values.domain;
          return (
            <FormikForm>
              <DomainInput
                label={
                  isSubdomainMode
                    ? t("projects.Subdomain Name")
                    : t("projects.Domain Name")
                }
                placeholder={
                  isSubdomainMode
                    ? "yoursubdomain.domain.com"
                    : "yourowndomain.com"
                }
                errorApollo={error}
                name="domain"
                className={touched.domain && errors.domain ? "is-invalid" : ""}
                style={{ zIndex: 2, backgroundImage: "none" }}
                autoComplete="off"
              />

              <Button
                variant="primary"
                className="w-100 text-white fw-bold mt-5"
                type="submit"
                disabled={setDomainUrlLoading}
              >
                {t("projects.Continue")} {setDomainUrlLoading && <Spinner />}
              </Button>
            </FormikForm>
          );
        }}
      </Formik>
    </Col>
  );
}
